<template>
  <b-modal
    id="modalCreateCalculationProductionAddWorkersAll"
    v-model="localActive"
    title="Показывать в таблице должности"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-add-workers-all">
      <svg
        class="m-add-workers-all-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-add-workers-all-title">Добавить сотрудников</div>

      <c-tabs
        id="tabsAddWorkersAll"
        ref="tabs"
        class="m-add-workers-all-tabs"
        style="visibility: hidden"
        :active="activeTab"
        :items="tabs.items"
        @change="changeTab"
      />

      <div class="m-add-workers-all-search">
        <c-switcher v-model="isShowWorkersAllFilials" class="m-add-workers-all-search-switcher" label="Все филиалы" />
        <c-input
          v-model="search"
          class="m-add-workers-all-search-input"
          placeholder="Поиск по ФИО"
          icon="search"
          placeholder-style="italic"
          clearable
        />
      </div>

      <div class="position-relative">
        <div id="m-add-workers-all-content-shadow-top" class="m-add-workers-all-content-shadow-top"></div>
        <div id="m-add-workers-all-content" class="m-add-workers-all-content" @scroll="setShadowsOnScroll">
          <div class="m-add-workers-all-content-result">
            <template v-for="(worker,i) in workersLocal">
              <c-switcher
                v-if="worker.isVisible && ((!isShowWorkersAllFilials && worker.is_filial) || isShowWorkersAllFilials)"
                :key="`worker-${worker.id}-${i}`"
                v-model="worker.isActive"
                class="m-add-workers-all-content-result-item"
                type="checkbox"
                :label="worker.name"
                :sub-label="`${worker.filial_name}, ${worker.post}`"
                @change="changeWorkerActive(worker)"
              />
            </template>
          </div>
          <div
            v-if="
              !workersLocal.some(
                (worker) =>
                  worker.isVisible && ((!isShowWorkersAllFilials && worker.is_filial) || isShowWorkersAllFilials),
              )
            "
            class="m-add-workers-all-content-empty"
          >
            Сотрудники не найдены
          </div>
        </div>
        <div id="m-add-workers-all-content-shadow-bottom" class="m-add-workers-all-content-shadow-bottom"></div>
      </div>

      <div class="m-add-workers-all-actions">
        <c-button size="large" class="m-add-workers-all-actions-reset" label="Сбросить" @click="reset()" />
        <c-button
          class="m-add-workers-all-actions-apply"
          label="Применить"
          color="blue"
          size="large"
          @click="submitWorkers()"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import { isProductionRankWithoutFixedSalary } from "@/entities/models/calculations";
import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import Switcher from "@/components/controls/switcher";
import Tabs from "@/components/tabs";
import Select2 from "@/components/controls2/Select";

export default {
  name: "m-production-add-workers-all",

  components: {
    "c-select-2": Select2,
    "c-input": Input,
    "c-button": Button,
    "c-switcher": Switcher,
    "c-tabs": Tabs,
  },

  props: ["active", "workers", "posts", "tableRecords", "data", "tab", "selected"],

  data() {
    return {
      groupCode: 'all',
      localActive: false,
      workersLocal: [],
      workersStatesLocal: [],
      isShowWorkersAllFilials: false,
      search: "",
      sumHoursWorked: 0,
      activeTab: null,
      tabs: {
        items: [],
      },
    };
  },

  watch: {
    isShowWorkersAllFilials() {
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.search = "";
          this.isShowWorkersAllFilials = false;
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    posts(value) {
      if (value !== undefined && value.length !== 0) {
        const otherTabs = value.map((post) => ({ label: post.name, value: post.code }));

        this.tabs.items = [{ label: 'Все', value: 'all' }, ...otherTabs];

        const sortedTabs = this.tabs.items.slice(1).sort((a, b) => a.label.localeCompare(b.label));

        this.tabs.items = [this.tabs.items[0], ...sortedTabs];

        this.activeTab = 'all';
        this.groupCode = this.activeTab;
        this.getWorkersItems(this.workers, this.selected, this.activeTab);
      } else {
        this.tabs.items = [];
      }
    },
    search(value) {
      if (value.length > 0) {
        this.workersLocal.forEach((post) => {
          post.isVisible = post.name.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.workersLocal.forEach((post) => {
          post.isVisible = true;
        });
      }
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },
  },

  methods: {
    changeTab(groupCode) {
      this.search = "";
      this.groupCode = groupCode;
      this.getWorkersItems(this.workers, this.selected, groupCode);
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },

    changeSelected() {
      this.workersLocal.map((worker) => {
        const index = this.selected.findIndex((workerActive) => workerActive === worker.key);
        if (worker.isActive && index==-1) this.selected.push(worker.key);
        else if (!worker.isActive && index>=0) this.selected.splice(index, 1);
      });
    },

    getWorkersItems(workers, selected, groupCode) {
      this.changeSelected();
      if (groupCode === 'all') {
        this.workersLocal = workers.map((worker) => {
          const b = this.selected.findIndex((workerActive) => workerActive === worker.key);
          return {
            is_filial: worker.is_filial ? worker.is_filial : false,
            id: worker.worker_id,
            key: worker.key,
            name: worker.showname,
            post_code: worker.post_code,
            post: worker.post,
            filial_name: worker.filial_name || 'Без филиала',
            isActive: b !== -1,
            isVisible: true,
          };
        });
      } else {
        const c = this.tableRecords.findIndex((group) => group.code === groupCode);
        let activeWorkersCurrentPost = [];
        if (c !== -1) {
          activeWorkersCurrentPost = this.tableRecords[c].records;
        }

        if (this.tab === "byDate") {

          this.workersLocal = workers
            .filter((worker) => worker.post_code === groupCode)
            .map((worker) => {
              const b = this.selected.findIndex((workerActive) => workerActive === worker.key);
              return {
                is_filial: worker.is_filial ? worker.is_filial : false,
                id: worker.worker_id,
                key: worker.key,
                name: worker.showname,
                post_code: worker.post_code,
                post: worker.post,
                filial_name: worker.filial_name || 'Без филиала',
                isActive: b !== -1,
                isVisible: true,
              };
            });

        } else {
          this.workersLocal = workers
            .filter((worker) => worker.post_code === groupCode)
            .map((worker) => {
              const defaultPersonalHistory = [
                {
                  type: worker.personal > 0 ? "+" : "-",
                  amount: Math.abs(Math.round(worker.personal)),
                  authorName: "vpadmin",
                  comment: null,
                  reason: null,
                  reason_id: null,
                },
              ];
              // console.log(worker.is_filial, worker.is_filial ? worker.is_filial : false);
              const b = activeWorkersCurrentPost.findIndex((workerActive) => workerActive.id === worker.worker_id);
              const findReferenceDataWorker = this.data.production[`${worker.worker_id}-${worker.post_code}`];
              if (findReferenceDataWorker !== undefined) {
                return {
                  is_filial: worker.is_filial ? worker.is_filial : false,
                  codeGroup: worker.post_code,
                  id: worker.worker_id,
                  name: worker.showname,
                  doc_problem: findReferenceDataWorker.doc_problem,
                  recommened_category: findReferenceDataWorker.recommened_category,
                  category_id: worker.category_id,
                  category_number: worker.category_number,
                  worktime: worker.worktime,
                  sum_compens: worker.sum_compens,
                  sum_deposit: worker.sum_deposit,
                  sum_surcharge: worker.sum_surcharge,
                  premium_personal_account: {
                    value: `${Math.round(
                      findReferenceDataWorker.personal_amount,
                    )}`,
                  },
                  personal_account_transactions: {
                    value: Math.round(worker.personal),
                    items:
                      worker.personal_history && worker.personal_history.length > 0
                        ? worker.personal_history
                        : defaultPersonalHistory,
                  },
                  personal_account_accrued: {
                    value: Math.round(worker.sum),
                  },
                  account_accrued: Math.round(worker.sum),
                  account_removed: Math.round(worker.sum_prepay),
                  account_balance: Math.round(worker.personal),
                  personal_account_removed: {
                    value: Math.round(worker.sum_prepay),
                  },
                  personal_account_balance: {
                    value: Math.round(worker.personal),
                  },
                  count_smenas: {
                    value: worker.count_smenas,
                  },
                  period_rank: {
                    value: worker.category_number,
                  },
                  period_compensation: {
                    value: worker.sum_compens,
                  },
                  period_working_time: {
                    value: this.convertHoursToHHMM(worker.worktime),
                  },
                  load: {
                    value: worker.count_products,
                  },
                  salary: {
                    value: Math.round(worker.s_salary),
                  },
                  main_part_salary: {
                    value: isProductionRankWithoutFixedSalary(worker.category_number)
                      ? 0
                      : Math.round((worker.s_salary / 12) * this.sumHoursWorked),
                  },
                  revenue_standard_hour: {
                    value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                  },
                  ratio_standart: {
                    value: worker.s_koutput,
                  },
                  revenue_standard: {
                    value: Math.round(worker.normday),
                  },
                  bonus_rate: {
                    value: worker.s_kbonus,
                  },
                  deprivation_coefficient: {
                    value: worker.s_kpenaly,
                  },
                  corrected_time: {
                    value: this.convertHoursToHHMM(worker.worktime_correctly),
                  },
                  premium_for_exceeding_standard: {
                    value: Math.round(worker.sum_bonus_calc),
                  },
                  depreciation: {
                    value: Math.round(worker.sum_penalty_calc),
                  },
                  prize: {
                    value: worker.sum_bonus,
                    items: worker.bonuses,
                  },
                  fine: {
                    value: worker.sum_penalty,
                    items: worker.fines,
                  },
                  total_accrued: {
                    value: Math.round(worker.sum),
                  },
                  already_paid: {
                    value: Math.round(worker.sum_prepay) * -1,
                  },
                  to_payoff: {
                    value: Math.round(worker.sum_paid),
                  },
                  isActive: b !== -1,
                  isVisible: true,
                  isShowRow: true,
                };
              }
              return {
                is_filial: worker.is_filial ? worker.is_filial : false,
                codeGroup: worker.post_code,
                id: worker.worker_id,
                name: worker.showname,
                doc_problem: 0,
                recommened_category: 0,
                category_id: worker.category_id,

                worktime: worker.worktime,
                sum_compens: worker.sum_compens,
                sum_deposit: worker.sum_deposit,
                sum_surcharge: worker.sum_surcharge,
                premium_personal_account: {
                  value: `${0}`,
                },
                personal_account_transactions: {
                  value: Math.round(worker.personal),
                  items:
                    worker.personal_history && worker.personal_history.length > 0
                      ? worker.personal_history
                      : defaultPersonalHistory,
                },
                account_accrued: Math.round(worker.sum),
                account_removed: Math.round(worker.sum_prepay),
                account_balance: Math.round(worker.personal),

                personal_account_accrued: {
                  value: Math.round(worker.sum),
                },
                personal_account_removed: {
                  value: Math.round(worker.sum_prepay),
                },
                personal_account_balance: {
                  value: Math.round(worker.personal),
                },
                count_smenas: {
                  value: worker.count_smenas,
                },
                period_working_time: {
                  value: this.convertHoursToHHMM(worker.worktime),
                },
                period_rank: {
                  value: worker.category_number,
                },
                period_compensation: {
                  value: worker.sum_compens,
                },
                load: {
                  value: worker.count_products,
                },
                salary: {
                  value: worker.s_salary,
                },
                main_part_salary: {
                  value: isProductionRankWithoutFixedSalary(worker.category_number)
                    ? 0
                    : Math.round((worker.s_salary / 12) * this.sumHoursWorked),
                },
                revenue_standard_hour: {
                  value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                },
                ratio_standart: {
                  value: worker.s_koutput,
                },
                revenue_standard: {
                  value: Math.round(worker.normday),
                },
                bonus_rate: {
                  value: worker.s_kbonus,
                },
                deprivation_coefficient: {
                  value: worker.s_kpenaly,
                },
                corrected_time: {
                  value: this.convertHoursToHHMM(worker.worktime_correctly),
                },
                premium_for_exceeding_standard: {
                  value: Math.round(worker.sum_bonus_calc),
                },
                depreciation: {
                  value: Math.round(worker.sum_penalty_calc),
                },
                prize: {
                  value: worker.sum_bonus,
                  items: worker.bonuses,
                },
                fine: {
                  value: worker.sum_penalty,
                  items: worker.fines,
                },
                total_accrued: {
                  value: Math.round(worker.sum),
                },
                already_paid: {
                  value: Math.round(worker.sum_prepay) * -1,
                },
                to_payoff: {
                  value: Math.round(worker.sum_paid),
                },
                isActive: b !== -1,
                isVisible: true,
                isShowRow: true,
              };
            });
        }

        this.workersLocal.sort((a, b) => a.name.localeCompare(b.name));
        this.workersStatesLocal = JSON.parse(JSON.stringify(this.workersLocal));
      }
    },
    onShowModal() {
      this.getWorkersItems(this.workers, this.selected, this.activeTab);
      setTimeout(() => {
        this.$refs.tabs.setShowMoreButtonTabs();
        setTimeout(() => {
          const tabsAddWorkersAll = document.getElementById("tabsAddWorkersAll");
          tabsAddWorkersAll.style.visibility = "visible";
        }, 100);
      }, 200);
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("m-add-workers-all-content-shadow-bottom");
      const shadowTopElement = document.getElementById("m-add-workers-all-content-shadow-top");
      const scrollElement = document.getElementById("m-add-workers-all-content");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-add-workers-all-content-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-add-workers-all-content-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("m-add-workers-all-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-add-workers-all-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-add-workers-all-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-add-workers-all-content-shadow-bottom-active");
        }
      }
    },
    reset() {
      setTimeout(() => {
        this.search = "";
        this.workersLocal = JSON.parse(JSON.stringify(this.workersStatesLocal));
      }, 200);
      this.localActive = false;
    },
    submitWorkers() {
      this.changeSelected();
      // console.log(this.workersLocal)
      this.$emit("submitWorkers", {
        workers: this.workersLocal,
        codeGroup: null,
        selected: this.selected,
      });
      this.localActive = false;
    },
    changeWorkerActive(worker) {
      // console.log(worker);
    },
    getAmountWorkerTime(intervals) {
      let sumHoursWorked = 0;
      intervals.forEach((interval) => {
        const start = moment(interval.start);
        const end = moment(interval.finish);
        const duration = moment.duration(end.diff(start)).asHours();
        sumHoursWorked += duration;
      });
      this.sumHoursWorked = sumHoursWorked;
      const n = new Date(0, 0);
      n.setSeconds(+sumHoursWorked * 60 * 60);
      return n.toTimeString().slice(0, 5);
    },
    convertHoursToHHMM(decimalTimeString) {
      let decimalTime = parseFloat(decimalTimeString);
      decimalTime = decimalTime * 60 * 60;
      let hours = Math.floor(decimalTime / (60 * 60));
      decimalTime -= hours * 60 * 60;
      let minutes = Math.floor(decimalTime / 60);
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${hours}:${minutes}`;
    },
    getRevenueStandardHour() {
      if (this.tab === "byDate") {
        const c = this.data.calc.production.posts.findIndex((post) => post.post_code === this.groupCode);
        if (c !== -1) {
          return this.data.calc.production.posts[c].s_norm;
        }
        return 0;
      }

      if (this.tab === "byPeriod") {
        const c = this.data.period.production.posts.findIndex((post) => post.post_code === this.groupCode);
        if (c !== -1) {
          return this.data.period.production.posts[c].s_norm;
        }
        return 0;
      }

      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-add-workers-all {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-tabs {
    margin-top: 26px;

    //&::v-deep .c-tabs {
    //  padding: 0;
    //  width: calc(100% + 60px);
    //}

    &::v-deep .c-tabs-item-more-container-list-item {
      padding: 5px 14px;
    }

    &::v-deep .c-tabs-shadow {
      left: -30px;
      width: calc(100% + 60px);
    }
  }

  &-search {
    margin-top: 26px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      align-items: flex-start;
      flex-direction: column;
    }

    &-switcher {
      max-width: 135px;
      margin-right: 30px;
    }

    &-input {
      width: 70%;

      @media screen and (max-width: 700px) {
        margin-top: 25px;
        width: 100%;
      }
    }
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-content {
    margin-top: 27px;
    overflow-y: auto;
    max-height: 397px;

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 250px);
    }

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #dfe4ef;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: transparent;
      opacity: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;

      &-active {
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        opacity: 1;
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    &-result {
      &-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &-actions {
    display: flex;
    margin-top: 22px;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
    }

    &-reset {
      background: white;

      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-apply {
      margin-left: 12px;

      @media screen and (max-width: 700px) {
        width: 50%;
        margin-left: 0;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          border-radius: 0;
          width: 100%;
        }
      }
    }
  }
}
</style>
